import React from 'react';
import './SideDrawer.css';

const sideDrawer = props => {
    let drawerClasses = 'side-drawer';
    if(props.show) {
        drawerClasses = 'side-drawer open';
    }
    return (
        <nav className={drawerClasses}>
            <ul>
                <li>
                    <a href="/?Home">Home</a>
                </li>
                <li>
                    <a href="/?About" >About Us</a>
                </li>
                <li>
                    <a href="/?Book">Book an RV</a>
                </li>
                <li>
                    <a href="/?Faq">FAQs</a>
                </li>
                <li>
                    <a href="/?Contact">Contact Us</a>
                </li>
            </ul>
    </nav>
    )
};

export default sideDrawer;